import React, { useState } from 'react';
import axios from 'axios';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import TextField from '@mui/material/TextField';
import LeftPanel from '../components/LeftPanel';
import PrimaryButton from '../components/PrimaryButton';

function InviteAdmin() {
    const [form, setForm] = useState({ firstName: '', lastName: '', email: '', inviterUserId: '' });
    const [submitting, setSubmitting] = useState(false);

    const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

    const handleSubmit = async e => {
        e.preventDefault();
        setSubmitting(true);
        try {
            await axios.post('/api/admin/invite/create', null, { params: form });
            // simple feedback for now
            alert('Invite created (email sending stubbed)');
            setForm({ firstName: '', lastName: '', email: '', inviterUserId: '' });
        } finally {
            setSubmitting(false);
        }
    };

    return (
        <Box component="main">
            <Grid container spacing={4} sx={{ mt: 2 }}>
                <Grid item xs={12} md={4} lg={3}>
                    <LeftPanel items={["Create an admin invite.", "Provide your User ID and the invitee details.", "Invites are emailed (stubbed)."]}>
                        <PrimaryButton sx={{ bgcolor: '#fff', color: '#000', textTransform: 'none' }}>Help</PrimaryButton>
                    </LeftPanel>
                </Grid>

                <Grid item xs={12} md={8} lg={6}>
                    <Paper elevation={1} sx={{ p: { xs: 3, md: 4 } }}>
                        <Typography variant="h5" sx={{ fontWeight: 700, mb: 2 }}>Invite Admin</Typography>

                        <Box component="form" onSubmit={handleSubmit} noValidate>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <TextField label="Your User ID" name="inviterUserId" value={form.inviterUserId} onChange={handleChange} fullWidth required />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField label="First Name" name="firstName" value={form.firstName} onChange={handleChange} fullWidth required />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField label="Last Name" name="lastName" value={form.lastName} onChange={handleChange} fullWidth required />
                                </Grid>
                                <Grid item xs={12}>
                                    <TextField label="Email" name="email" type="email" value={form.email} onChange={handleChange} fullWidth required />
                                </Grid>
                                <Grid item xs={12}>
                                    <PrimaryButton type="submit" disabled={submitting}>Invite Admin</PrimaryButton>
                                </Grid>
                            </Grid>
                        </Box>
                    </Paper>
                </Grid>
            </Grid>
        </Box>
    );
}
export default InviteAdmin;
